import {Fancybox} from "@fancyapps/ui";
import Swiper, {Navigation, Pagination, Thumbs} from 'swiper';
import events from "./base";
import {notice} from "./Components/UI/notice";
import Choices from 'choices.js';

Swiper.use([Navigation, Thumbs, Pagination]);
import JsTabs from 'js-tabs';
import Agent from "./Components/Core/agent";
import {numberFormat, parseBool, parseHTML} from "./Components/Core/common";

require('./base');


window.noty = notice;


if (document.querySelector(".main-filter__tabs")) {
    let tabs = async () => await import('./Components/tabs');
    tabs().then(e => e.init(".main-filter__tabs"));
}


if (document.querySelector('.category-show')) {
    let block = document.querySelector('.category-show');
    let btns = document.querySelectorAll('.btn-show');
    let items = block.querySelectorAll('.product-item');
    btns.forEach(item => {
        item.addEventListener('click', () => {
            btns.forEach(item => item.classList.remove('active'));
            item.classList.add('active');
            if (item.classList.contains('inline-show')) {
                block.classList.remove('grid-block');
                block.classList.add('inline-block');
                items.forEach(item => item.classList.add('inline-block'));
            } else {
                block.classList.add('grid-block');
                block.classList.remove('inline-block');
                items.forEach(item => item.classList.remove('inline-block'));
            }
        });
        if (item.classList.contains('grid-show')) {
            item.classList.add('active');
        }
    });
}


document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.slider-baner').forEach(item => {
        let currentNavigation = document.querySelectorAll(`.slider-navigation-baner`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = '.slider-navigation-baner .slider-next';
            let prev = '.slider-navigation-baner .slider-prev';
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: '.slider-navigation-baner .slider-pagination',
                    type: 'fraction',
                };
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 1,
            navigation: navigation,
            pagination: pagination,
            slideActiveClass: "active",
        });
    });
    document.querySelectorAll('.slider-2').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-2[data-category="${currentCategory}"]`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets',
                    dynamicBullets: true,
                    dynamicMainBullets: 1,
                };
        }
        if (item.querySelectorAll('.swiper-slide').length < 6) {
            currentNavigation.querySelector('.slider-pagination').classList.add('justify-content-center');
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 20,
            slidesPerView: 1,
            navigation: navigation,
            pagination: pagination,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                576: {
                    slidesPerView: 1,
                    spaceBetween: 30,
                },
                1200: {
                    slidesPerView: 2,
                    spaceBetween: 60,
                }
            }
        });

    });
    document.querySelectorAll('.slider-4').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-4[data-category="${currentCategory}"]`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets',
                    dynamicBullets: true,
                    dynamicMainBullets: 1,
                };
        }
        if (item.querySelectorAll('.swiper-slide').length < 6) {
            currentNavigation.querySelector('.slider-pagination').classList.add('justify-content-center');
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 'auto',
            navigation: navigation,
            pagination: pagination,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                768: {
                    slidesPerView: 3,
                },
                992: {
                    slidesPerView: 3,
                },
                1200: {
                    slidesPerView: 4,
                },
                1340: {
                    slidesPerView: 4,
                }
            }
        });

    });
    document.querySelectorAll('.slider-5').forEach(item => {
        let currentCategory = item.dataset.category;
        let currentNavigation = document.querySelector(`.slider-navigation-5[data-category="${currentCategory}"]`);
        let navigation = {};
        let pagination = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            },
                pagination = {
                    el: currentNavigation.querySelector('.slider-pagination'),
                    type: 'bullets',
                    dynamicBullets: true,
                    dynamicMainBullets: 1,
                };
        }
        if (item.querySelectorAll('.swiper-slide').length < 6) {
            currentNavigation.querySelector('.slider-pagination').classList.add('justify-content-center');
        }
        new Swiper(item, {
            modules: [Navigation, Pagination],
            spaceBetween: 10,
            slidesPerView: 2,
            navigation: navigation,
            pagination: pagination,
            watchSlidesVisibility: true,
            slideActiveClass: "active",
            breakpoints: {
                576: {
                    slidesPerView: 3
                },
                768: {
                    slidesPerView: 4,
                },
                1200: {
                    slidesPerView: 5,
                }
            }
        });

    });
    document.querySelectorAll('.slider-product').forEach(productSlider => {
        let currentNavigation = document.querySelector(`.slider-product-thumbs-wrapper`);
        let navigation = {};
        if (currentNavigation) {
            let next = currentNavigation.querySelector('.slider-next');
            let prev = currentNavigation.querySelector('.slider-prev');
            navigation = {
                nextEl: next,
                prevEl: prev,
            }
        }
        let swiperProductThumbs = new Swiper('.slider-product-thumbs', {
            slidesPerView: 'auto',
            spaceBetween: 10,
            breakpoints: {
                576: {
                    slidesPerView: 3,
                },
                1340: {
                    slidesPerView: 4,
                }
            }
        });
        const swiperDefOpt = {
            spaceBetween: 10,
            slidesPerView: 'auto',
            breakpoints: {
                992: {
                    slidesPerView: 1,
                },
            }
        }
        const swiperProductOpt = {
            modules: [Thumbs, Navigation],
            thumbs: {
                swiper: swiperProductThumbs
            },
            navigation: navigation,
        }
        if (document.querySelector('.slider-product-thumbs')) {
            new Swiper(productSlider, Object.assign({}, swiperDefOpt, swiperProductOpt));
        } else {
            new Swiper(productSlider, Object.assign({}, swiperDefOpt));
        }
    })
});


const searchChoices = new Map;
const searchChoicesButton = document.querySelector('.js_search_filter_button');
const searchChoicesBlock = document.querySelector('.js_select_block');

if(searchChoicesButton){
    searchChoicesButton.addEventListener('click', () => {
        let id = +searchChoicesButton.dataset.id;
        if (id > 0) {
            searchChoicesButton.classList.add('preloader');
            Agent.post('/api/get_url.html', JSON.stringify({id}), {
                headers: {
                    'Content-Type': 'application/json;'
                }
            }).then(
                e => e.json()
            ).then(e => {
                if (e.success) {
                    document.location.href = e.data;
                } else {
                    notice(e.message)
                }
            }).finally(() => searchChoicesButton.classList.remove('preloader'));
        }
    });
}

const searchChoicesChangeEvent = (choice) => {
    let isDelete = false;
    searchChoicesButton.dataset.id = choice.value;
    searchChoicesButton.disabled = true;

    searchChoices.forEach((value, key) => {
        if (isDelete) {
            value.destroy();
            key.removeEventListener('change', () => searchChoicesChangeEvent(key));
            searchChoices.delete(key)

            let parent = key.closest('.main-select');
            parent.parentNode.removeChild(parent);
        }
        if (isDelete || key === choice) {
            isDelete = true;
        }
    });

    if (parseBool(+choice.value) && parseBool(choice.dataset.isNext)) {
        searchChoicesButton.classList.add('preloader');
        Agent.post('/api/v1/spare-parts-category/', JSON.stringify({id: choice.value}), {
            headers: {
                'Content-Type': 'application/json;'
            }
        }).then(e => e.json())
            .then(e => {
                if (e.success) {
                    searchChoicesButton.disabled = false;

                    if (e.data.length) {
                        let newChoice = document.createElement("select");
                        newChoice.setAttribute("class", "main-select-item ps-xl-30 ps-20 pe-40 py-xl-20 py-15 fs-16 rounded-pill w-100 js-choice")
                        newChoice.add(new Option('Выбрать', 0));

                        e.data.forEach(e => {
                            let option = new Option(e.title, e.id)
                            newChoice.add(option);
                        });

                        let wrapper = document.createElement("div");
                        wrapper.setAttribute("class", "main-select position-relative");
                        wrapper.append(newChoice);
                        searchChoicesBlock.append(wrapper);

                        searchChoices.set(newChoice, new Choices(newChoice, {
                            itemSelectText: '',
                            position: 'bottom',
                            searchPlaceholderValue: newChoice.dataset.placeholder,
                        }));

                        newChoice.dataset.isNext = e.isNext || false;

                        newChoice.addEventListener('change', () => {
                            searchChoicesChangeEvent(newChoice)
                        })
                    }
                }
            })
            .finally(() => {
                searchChoicesButton.classList.remove('preloader');
            });
    } else if (+choice.value) {
        searchChoicesButton.disabled = false;
    }
}

document.querySelectorAll('.js-choice').forEach((choice, key) => {
    searchChoices.set(choice, new Choices(choice, {
        itemSelectText: '',
        position: 'bottom',
        searchPlaceholderValue: choice.dataset.placeholder,
    }));
    choice.dataset.isNext = true;
    choice.addEventListener('change', function () {
        searchChoicesChangeEvent(choice)
    })
});


const choiceSearchSelect = document.querySelector('.js-choice_search');

if (choiceSearchSelect) {
    const choiceSearch = document.querySelector('[name="gear-number"]');
    const choiceSearchButton = document.querySelector('.js_gear_number_button');
    const choiceSearchResult = document.querySelector('.js-choice_search_result');

    new Choices(choiceSearchSelect, {
        itemSelectText: '',
        position: 'bottom',
        searchPlaceholderValue: choiceSearchSelect.dataset.placeholder,
    });

    choiceSearchSelect.addEventListener('change', function () {
        choiceSearchButton.disabled = !(choiceSearch.value.trim().length);
        choiceSearchResult.innerHTML = '';
    })


    choiceSearch.addEventListener('input', () => {
        choiceSearchButton.disabled = !parseBool(choiceSearch.value.trim().length);
        choiceSearchResult.innerHTML = '';
    });


    if (choiceSearchButton) {
        choiceSearchButton.addEventListener('click', function () {
            choiceSearchResult.innerHTML = '';
            if (!choiceSearch.disabled) {
                choiceSearchButton.classList.add('preloader');
                choiceSearchSelect.disabled = true;
                choiceSearch.disabled = true;
                choiceSearchButton.disabled = true;
                Agent.post('/api/v1/parts/search/', JSON.stringify({
                    brand: choiceSearchSelect.value,
                    phrase: choiceSearch.value,
                    _csrf_token: document.querySelector("[name='_csrf_token']").value
                }), {
                    headers: {
                        'Content-Type': 'application/json;'
                    }
                }).then(e => e.json())
                    .then(e => {
                        if(e.success){
                            if (e.data.length){
                                e.data.forEach(e => {
                                    let price = parseFloat(e.price) > 0 ? `<div class="gear-item__desc-price fs-14 lh-1_1 fw-sb">${numberFormat(e.price)} ₽/шт</div>` : ''
                                    let addToCartButton = parseFloat(e.price) > 0? `<button class="btn btn-icon js_add_to_cart" data-id="${ e.id }"><i class="icon u_shopping-cart fs-20"></i></button>` : '';
                                    let el = parseHTML(`<div class="gear-item d-flex js_item">
                                    <a class="gear-item__main d-flex align-items-center p-5 rounded-15 flex-grow-1" 
                                        href="${e.url}"
                                    >
                                        <div class="gear-item__desc flex-grow-1 d-flex align-items-center justify-content-between gap-15 px-sm-15 px-10 py-5">
                                            <div class="d-flex flex-column gap-2">
                                                <div class="fs-14 lh-1_1 fw-sb">${e.title} - ${e.code}</div>
                                                <div class="fs-14 lh-1_1">${e.category}</div>
                                            </div>
                                            ${price}
                                        </div>
                                    </a>
                                    <div class="gear-item__btns d-flex flex-column flex-sm-row gap-xl-15 gap-10 p-xl-15 p-10">
                                        <button class="btn btn-icon js_add_favorites" data-type="33" data-id="${e.id}"><i class="icon u_star fs-20"></i></button>
                                        ${addToCartButton}
                                    </div>
                                </div>`)
                                    choiceSearchResult.append(el);
                                });
                                events.dispatch('filter.search');
                            }else {
                                choiceSearchResult.innerHTML = '<p>По вашему запросу ничего не найдено</p>';
                            }
                        }else {
                            notice(e.message||"Ошибка при поиске");
                        }
                    }).finally(() => {
                    choiceSearchButton.classList.remove('preloader');
                    choiceSearchSelect.disabled = false;
                    choiceSearch.disabled = false;
                    choiceSearchButton.disabled = false;
                })
            }
        })
    }
}

let filterListInputTimer;
document.querySelectorAll('.js_search_for_node').forEach(item => {

    item.addEventListener('input', () => {
        clearTimeout(filterListInputTimer);
        filterListInputTimer = setTimeout(function() {
            let filter = item.value.toUpperCase();
            document.querySelectorAll('[name="name_node_item"]').forEach(l => {
                let is = l.value.toUpperCase().indexOf(filter) > -1;
                if (is) {
                    l.closest('.js_item').classList.remove('d-none');
                } else {
                    l.closest('.js_item').classList.add('d-none');
                }
            });
        }, 300);
    });
});

import yanmap from './Ymaps';

if (document.querySelectorAll('#map')) {
    yanmap.load()
        .then(ymaps => {
            if (document.querySelector('.js_office_map')) {
                //создание карты
                const myMap = new ymaps.Map("map", {
                    center: [57.05, 65.83], zoom: 4,

                });
                // myMap.behaviors.disable('scrollZoom')
                //Добавление точек из адресов на странице
                let points = new Map;
                document.querySelectorAll('.js_office_coordinates').forEach(item => {
                    let category = item.dataset.category;
                    let placemark = new ymaps.Placemark([item.dataset.latitude, item.dataset.longitude], {}, {preset: 'islands#greenIcon'})
                    points.set(category, placemark)
                });

                //Добавление точек на карту
                let myClusterer = new ymaps.Clusterer({preset: 'islands#greenClusterIcons'});

                for (let point of points.values()) {
                    myClusterer.add(point);
                }
                myMap.geoObjects.add(myClusterer);
                document.querySelectorAll('.js_office_coordinates').forEach(item => {
                    item.addEventListener('click', function () {
                        document.querySelectorAll('.js_office_coordinates').forEach(item => item.classList.remove('active'));
                        if (window.outerWidth < 992) {
                            document.querySelector('.points-map').scrollIntoView({block: "start", behavior: "smooth"});
                        }
                        item.classList.add('active');
                        myMap.setCenter([+item.dataset.latitude, +item.dataset.longitude], 16, {
                            checkZoomRange: true, duration: 500, timingFunction: 'ease'
                        });
                    })
                })
            } else if (document.querySelector('.js_contact_map')) {
                const myMap = new ymaps.Map("map", {
                    center: [43.115542, 131.885494], zoom: 10,
                });
            }

        }).catch(error => console.log('Failed to load Yandex Maps', error));
}